<template lang="pug">
  .pbxx_color_picker
    el-color-picker(
      v-model='current_color'
      @change='change_color')
    el-input.color_picker_input(
      name='color'
      v-model='current_color'
      @input='change_color'
      v-validate="{ required: true, regex: /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/ }")
    .form_error
      span
        | {{ errors.first('color') }}
</template>

<script>
  export default {
    name: 'pbxx_color_picker',
    props: {
      change: {
        type: Function,
        required: false
      },
      color: {
        type: String,
        required: false
      }
    },
    $_veeValidate: {
      validator: 'new' // give me a new validator each time.
    },
    data() {
      return {
        current_color: this.color
      }
    },
    methods: {
      async change_color() {
        await this.$validator.validate()
        .then(result => {
          if (result) {
            this.$emit('input', this.current_color)
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .el-color-dropdown__btns {
    .el-color-dropdown__link-btn {
      display: none; // Hide clear button
    }
  }
</style>

<style lang="scss" scoped>
  .form_error {
    color: red;
  }

  .el-color-picker {
    vertical-align: top;
  }

  .color_picker_input {
    display: inline-block;
    width: 200px;
    margin-left: 10px;
  }
</style>
